import styled from 'styled-components'

export const StyledWrapper = styled.div`
  table {
    border-collapse: collapse !important;
  }

  table,
  tr,
  td,
  th {
    border: none !important;
  }

  th {
    border-bottom: none !important;
  }

  .fc-timegrid-slot {
    padding-top: 80px !important;
  }

  .fc-timegrid-col {
    padding-top: 80px !important;
  }

  /* .fc tr:nth-child(2n + 0) .fc-timegrid-slot-minor {
    border-top: 1px solid rgba(255, 255, 255, 0.24) !important;
  } */

  .fc tr:nth-child(2n + 3) .fc-timegrid-slot {
    border-top: 1px solid rgba(255, 255, 255, 0.14) !important;
  }

  .fc .fc-timegrid-slot-minor {
    border-top: 1px solid rgba(255, 255, 255, 0.14) !important;
    background-color: white !important;
  }

  .fc-theme-standard td {
    border-right: 1px solid rgba(255, 255, 255, 0.14) !important;
  }

  .fc .fc-timegrid-slot-label {
    border-top: none !important;
  }

  .fc-timegrid-event-harness-inset .fc-timegrid-event,
  .fc-timegrid-event.fc-event-mirror,
  .fc-timegrid-more-link {
    box-shadow: none !important;
  }

  .fc-button {
    margin-right: 20px !important;
    border-radius: 50% !important;
  }

  .fc .fc-button-primary {
    padding: 1px 5px;
  }

  /* .fc .fc-toolbar {
    justify-content: flex-start !important;
  }

  .fc .fc-button-group {
    padding-left: 30px;
  } */

  .fc .fc-toolbar.fc-header-toolbar {
    margin-top: 18.5px;
  }

  .fc .fc-toolbar-title {
    font-size: 18px;
    font-weight: 500;
  }

  .fc-toolbar-chunk {
    display: flex;
    align-items: center;
  }

  .fc .fc-button .fc-icon {
    font-size: 15px;
  }

  .fc .fc-view-harness {
    height: 100vh !important;
  }

  .fc-day-today {
    background-color: inherit !important;
  }

  .fc-event-time {
    font-size: 12px;
    padding: 0 10px;
  }

  .fc-event-title {
    font-size: 14px;
    font-weight: 700;
    padding: 10px;
    white-space: nowrap;
  }

  .fc-v-event:target {
    background-color: inherit !important;
  }
`

export const Square = styled.div<{ color: string }>`
  background-color: ${props => props.color};
  border-radius: 4px;
  height: 17px;
  margin-right: 8px;
  width: 17px;
`

export const Flexer = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
`

export const EventFlexer = styled.div`
  display: flex;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column
  `}
`
